module.exports = __webpack_public_path__ + "static/banner_1-4bc1849f8068f1cd7bdabea67b2df0ac.png";